export enum MessageEventDataType {
  LOGIN = "LOGIN",
}

export interface MessageEventDataPayloadMap {
  [MessageEventDataType.LOGIN]: {
    authCode: string;
  };
}

export interface MessageEventData<T extends MessageEventDataType> {
  type: T;
  payload: MessageEventDataPayloadMap[T];
}
